module.exports = __webpack_public_path__ + "media/apps/mitch-android-7-4270eb56.png";